import React, { useEffect, useState } from "react";
import axios from "axios";
import { getBlockchainNodeUrl, SERVER_BASE_ADDRESS } from "../../globals/const";
import {
  Box,
  Button,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Container,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { getTransferEmissions } from "../../globals/emissions";
import { getWalletFromLocal } from "../../globals/authentication";
import CustomAppBar from "../../components/AppBar";
import api from "../../globals/axios";

const CreateTransport = ({ balances }) => {
  const { tokenCode } = useParams();

  const [pendingTransfers, setPendingTransfers] = useState([]);
  const [initiatorWallet, setInitiatorWallet] = useState("");

  const [quantity, setQuantity] = useState(undefined);
  const destinationAddress = null;
  const [token, setToken] = useState("");
  const [wallet, setWallet] = useState({});
  const [emission, setEmission] = useState("");
  const [transportType, setTransportType] = useState("");
  const [distance, setDistance] = useState("");

  useEffect(() => {
    /**
     * Handle URL params
     */
    setToken({ parent_token_code: tokenCode });
    // setInitiatorWallet(e.target.value.initiator_wallet)
    // setQuantity(e.target.value.transfer_amount)
    console.log(token);
  }, [tokenCode]);

  useEffect(() => {
    /**
     * Get pending transfers from backend and set pendingTransfers to
     * [{
     *   'initiator_wallet' : (str) address for the initiator of the i-th pending smart contract
     *   'parent_token_code' : (str) token_code for the i-th token that has to be claimed
     *   'transfer_amount' : (int) amount of this token you are recieving
     * }]
     */
    const setData = async () => {
      const res = await api.get(
        `${SERVER_BASE_ADDRESS}/chain/pending-transfers`
      );
      setPendingTransfers(res.data.pending_transfers);
    };
    setData();
  }, []);

  useEffect(() => {
    if (balances && balances.length > 0) {
      setToken(balances[0].token_code);
    }
  }, [balances]);

  useEffect(() => {
    /** Set wallet from session storange */

    const loadWallet = async () => {
      const w = await getWalletFromLocal();
      setWallet(w);
    };

    loadWallet();
  }, []);

  useEffect(() => {
    /**Set  max quantity to wallet balance for each available token*/
    if (!balances) {
      axios
        .get(
          getBlockchainNodeUrl() +
            "/get-balances?balance_type=ALL_TOKENS_IN_WALLET&wallet_address=" +
            wallet.address
        )
        .then((res) => res.data.balance)
        .then((data) => {
          data = data.filter((t) => !t.token_code.startsWith("LAND"));
          if (data[0]) {
            setToken(data[0]?.token_code);
          }
        });
    }
  }, [wallet, balances]);

  useEffect(() => {
    /**Constant update of emissions */
    setEmission(getTransferEmissions(transportType, distance));
  });

  const transferToken = async () => {
    if (destinationAddress === wallet.address) {
      alert("You cannot transfer to yourself");
      return;
    }
    if (token in [null, undefined, ""]) {
      alert("Invalid token");
      return;
    }
    await addTransportation();
  };

  const addTransportation = async () => {
    /**Send relevant info for claiming original token from sc and
     * mutating it to correct transport token */

    const childTokenCode = "T" + token.parent_token_code;
    const tokenAttributes = {
      parent_token: token.parent_token_code,
      srcPlace: "",
      dstPlace: "",
      carbon_emission: emission,
      distance: distance,
      quantity: quantity,
    };

    api
      .post(`${SERVER_BASE_ADDRESS}/chain/claim-token`, {
        initiator_wallet: initiatorWallet,
        parent_token_code: token.parent_token_code,
        child_token_code: childTokenCode,
        child_token_attributes: tokenAttributes,
      })
      .then((result) => {
        console.log(result);
        alert("Transfer created successfully");
        window.open("/", "_self");
      })
      .catch((err) => {
        alert("Error - " + err.response.data.non_field_errors[0]);
      });
  };

  return (
    <>
      <CustomAppBar />

      <Container maxWidth="xs">
        <Box
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            marginTop: "20px",
            // marginLeft: '10%', marginRight: '10%',
          }}
        >
          <Typography variant="h6" mb={2}>
            Transport Commodity
          </Typography>
          <FormControl fullWidth>
            <InputLabel id="token-select-label">Token to claim</InputLabel>
            <Select
              labelId="token-select-label"
              id="token-select"
              value={token.parent_token_code}
              label="Token to send"
              onChange={(e) => {
                setToken(e.target.value);
                setInitiatorWallet(e.target.value.initiator_wallet);
                setQuantity(e.target.value.transfer_amount);
              }}
            >
              {pendingTransfers.map((transfer) => (
                <MenuItem key={transfer.parent_token_code} value={transfer}>
                  {transfer.parent_token_code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            required
            fullWidth
            sx={{ marginTop: 2 }}
            name="txtamount"
            label={quantity ? "" : "Quantity"}
            type="numeric"
            id="txtamount"
            value={quantity}
            InputProps={{
              readOnly: true,
              disableUnderline: true,
              style: { pointerEvents: "none" },
            }}
            // onChange={event => setQuantity(roundDec(parseFloat(event.target.value)))} HAVE TO ACCEPT ALL OF CONTRACT TOKENS
          />
          <Typography>Select source and destination</Typography>
          {/* <MapWithMarker
          center={{ lat: 12.9716, lng: 77.5946 }}
          zoom={10}
          srcCoords={srcCoords}
          dstCoords={dstCoords}
          setSrcCoords={setSrcCoords}
          setDstCoords={setDstCoords}
          /> */}
          <FormControl fullWidth sx={{ marginTop: 2 }}>
            <InputLabel id="transport-select-label">
              Transportation Mode
            </InputLabel>
            <Select
              margin="normal"
              labelId="select-transport-type-label"
              id="select-crop-type"
              value={transportType}
              label="Transportation Mode"
              onChange={(e) => {
                setTransportType(e.target.value);
              }}
            >
              <MenuItem value={"diesel"}>Diesel</MenuItem>
              <MenuItem value={"electricRenewable"}>
                Electric Renewable
              </MenuItem>
              <MenuItem value={"electricStandard"}>Electric Standard</MenuItem>
              <MenuItem value={"HFO"}>Ship/HFO</MenuItem>
            </Select>
          </FormControl>
          <TextField
            fullWidth
            margin="normal"
            name="txtamount"
            label="Kilometers"
            type="number"
            id="txtamount"
            value={distance}
            onChange={(event) => {
              setDistance(event.target.value);
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            name="txtamount"
            label="CO2 Emission (kgs)"
            type="number"
            id="txtamount"
            value={emission}
            InputLabelProps={{ shrink: true }}
          />
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => transferToken()}
            // size="small"
            color="primary"
            fullWidth
          >
            Transfer
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default CreateTransport;
